var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"id":"Layer_64","data-name":"Layer 64"}},[_c('path',{attrs:{"d":"M60,18.24H45.76V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V43.76a2,2,0,0,0,2,2H18.24V60a2,2,0,0,0,2,2H60a2,2,0,0,0,2-2V20.24A2,2,0,0,0,60,18.24ZM6,6H41.76V41.76H6ZM58,58H22.24V45.76H43.76a2,2,0,0,0,2-2V22.24H58Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }